'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fast';
var iconName = 'cloud-rainbow';
var width = 576;
var height = 512;
var aliases = [];
var unicode = 'f73e';
var svgPathData = 'M281.9 152.1C343.1 69.5 441.3 16 552 16l24 0 0-16-24 0c-115.7 0-218.4 55.9-282.6 142.1 4.3 3.1 8.5 6.5 12.5 10zM488.6 259.6c18-12.4 39.8-19.6 63.4-19.6l24 0 0-16-24 0c-30 0-57.5 10.3-79.4 27.6 5.5 2.4 10.9 5.1 16 8.1zm-71.4-86.6C454.7 144.8 501.4 128 552 128l24 0 0-16-24 0c-56 0-107.5 19.2-148.3 51.3 4.7 3 9.3 6.2 13.6 9.7zM176 160c-61.9 0-112 50.1-112 112l0 21.5C26.7 306.6 0 342.2 0 384l0 96 512 0 0-96c0-53-43-96-96-96l0-16c0-44.2-35.8-80-80-80-24.3 0-46.1 10.9-60.8 28-18.7-35.7-56.1-60-99.2-60zM80 272c0-53 43-96 96-96 41.3 0 76.6 26.1 90.1 62.8l5.9 16 8.5-14.8c11.1-19.2 31.8-32 55.5-32 35.3 0 64 28.7 64 64l0 33.1 8.7-.8c2.4-.2 4.8-.3 7.3-.3 44.2 0 80 35.8 80 80l0 80-480 0 0-80c0-36.6 24.6-67.5 58.2-77l5.8-1.6 0-33.4z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCloudRainbow = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;